import React from 'react'
import {
  TextField as MUITextField,
  TextFieldProps as MUITextFieldProps,
  MenuItem as SelectOption,
  styled
} from '@mui/material'

interface AdditionalTextFieldProps {
  gutterBottom?: boolean
}

export type TextFieldProps = MUITextFieldProps & AdditionalTextFieldProps

const TextFieldComponent: React.FC<TextFieldProps> = (props: TextFieldProps) => {
  const { gutterBottom, ...rest } = props
  return <MUITextField variant='standard' {...rest} />
}

const TextField = styled(TextFieldComponent)<TextFieldProps>(({ gutterBottom }) => {
  const gutterButtonStyles = {
    marginBottom: '12px'
  }
  return {
    ...((gutterBottom ?? false) && gutterButtonStyles)
  }
})

export {
  SelectOption
}

export default TextField
